const api = {
  GET_LIST_MOBILE_API_LOG: '/index.php?r=api/v1/system_log/service-log/mobil-api-log',
};

export default api;
